<template>
    <the-header ></the-header>

    <main>
        <div class="mainContents">
            <!-- <component :is="activePage"></component> -->
            <section class="part_contents">
                <router-view/>
            </section>

            <section class="part_side">
                <div class="wrapper-chat">
                    <chat-base chat_roomId='m1' :headerdisplay='true' :viewList="true"></chat-base>
                </div>
            </section>

        </div>

    </main>
    <the-footer/>
</template>

<script>
import TheHeader from '@/components/site/sub/TheHeader.vue';
import ChatBase from '@/components/chat/ChatBase.vue';
import TheFooter from '@/components/site/TheFooter';
export default {
    components: {
        TheHeader,
        ChatBase,
        TheFooter,
    },

}
</script>

<style lang="scss" scoped>

</style>
